// @ts-nocheck
/**
 * NPC Competitors and Deck Definitions
 * 大会に出場するNPCとデッキデータ
 *
 * Created: 2025-11-29
 */

// ============================================================
// NPC定義
// ============================================================

export const COMPETITORS = {
  // 基本8人（デイリー・ウィークリー用）
  kain: {
    id: 'kain',
    name: '炎帝カイン',
    attribute: '炎',
    portrait: '🔥',
    style: '速攻',
    personality: '熱血、直情的、負けず嫌い',
    appearance: '赤い鎧、炎の紋章、短髪',
    aiDifficulty: 'hard',  // 攻撃的なプレイスタイル
    quotes: {
      win: '燃え尽きろ！',
      lose: 'くっ...次は負けねぇ！',
      start: '全力で行くぜ！',
    },
    decks: ['紅蓮の咆哮', '血炎の呪い'],
  },

  seira: {
    id: 'seira',
    name: '氷姫セイラ',
    attribute: '水',
    portrait: '💧',
    style: 'コントロール',
    personality: '冷静、計算高い、少しツンデレ',
    appearance: '青いドレス、氷の髪飾り、長髪',
    aiDifficulty: 'hard',  // 計算高いコントロールプレイ
    quotes: {
      win: '計算通りね',
      lose: '...次は容赦しないわ',
      start: '凍り付きなさい',
    },
    decks: ['深海の支配者', '鎖縛のリアリス'],
  },

  rowen: {
    id: 'rowen',
    name: '聖騎士ロウェン',
    attribute: '光',
    portrait: '✨',
    style: 'バランス',
    personality: '真面目、正義感強い、堅実',
    appearance: '白い鎧、聖剣、金髪',
    aiDifficulty: 'hard',  // 堅実なバランス型
    quotes: {
      win: '正義は勝つ',
      lose: '...まだだ、まだ終わらん',
      start: '正々堂々と勝負だ',
    },
    decks: ['聖域の光', '雷帝の裁き'],
  },

  malik: {
    id: 'malik',
    name: '闇術師マリク',
    attribute: '闇',
    portrait: '🌙',
    style: 'バーン',
    personality: '陰険、策略家、不安定',
    appearance: '黒いローブ、仮面、不気味',
    aiDifficulty: 'hard',  // 策略家
    quotes: {
      win: '闇に飲まれろ',
      lose: '...くくく、面白い',
      start: '闇の力を見せてやる',
    },
    decks: ['闇鎖の舞踏', '死の女神'],
  },

  garon: {
    id: 'garon',
    name: '獣王ガロン',
    attribute: '原始',
    portrait: '🦁',
    style: 'ビート',
    personality: '単純、パワー重視、脳筋',
    appearance: '獣の毛皮、筋肉質、野性的',
    aiDifficulty: 'hard',  // 単純なパワープレイ
    quotes: {
      win: '力こそ全てだ！',
      lose: 'ぐおおっ...！',
      start: '粉砕してやる！',
    },
    decks: ['呪森の狩人', '密林の覚醒'],
  },

  nova: {
    id: 'nova',
    name: '機工士ノヴァ',
    attribute: '未来',
    portrait: '⚙️',
    style: 'コンボ',
    personality: '早口、発明狂、ムラがある',
    appearance: 'ゴーグル、白衣、工具ベルト',
    aiDifficulty: 'hard',  // コンボ重視
    quotes: {
      win: '計算通りなのだ！',
      lose: '計算が...狂ったのだ...',
      start: '実験開始なのだ！',
    },
    decks: ['紫鴉の預言者', '星灯のエクラシア'],
  },

  mask: {
    id: 'mask',
    name: '謎の仮面',
    attribute: '混合',
    portrait: '🎭',
    style: '禁忌軸',
    personality: '謎めいてる、読めない',
    appearance: '全身黒、仮面、正体不明',
    aiDifficulty: 'hard',  // 読めない強敵
    quotes: {
      win: '...予定通り',
      lose: '...',
      start: '...始めよう',
    },
    decks: ['闇の預言者', 'ランダム'],
  },

  toma: {
    id: 'toma',
    name: '新人トーマ',
    attribute: '混合',
    portrait: '🌱',
    style: '初心者',
    personality: '素直、頑張り屋、運任せ',
    appearance: '普通の青年、緊張した顔',
    aiDifficulty: 'hard',  // 初心者
    quotes: {
      win: 'や、やりました！',
      lose: 'うう...頑張ります...',
      start: '頑張ります！',
    },
    decks: ['プニリーヌの騎士団', '密林の小さな命'],
  },

  // 追加NPC（グランドカップ用）
  elda: {
    id: 'elda',
    name: '森の賢者エルダ',
    attribute: '光',
    portrait: '🌳',
    style: '持久戦',
    personality: '穏やか、知識豊富、自然を愛する',
    appearance: '緑のローブ、木の杖、白髭の老人',
    aiDifficulty: 'hard',  // 穏やかな持久戦
    quotes: {
      win: '自然の摂理じゃよ',
      lose: 'ふむ...良い勉強になったわい',
      start: '若者よ、全力で来るがよい',
    },
    decks: ['聖なる巨鳥', '天翔の覇王'],
  },

  // コレクター6人
  pippo: {
    id: 'pippo',
    name: 'ピッポ',
    attribute: '炎/原始',
    portrait: '😤',
    style: 'コレクター',
    personality: '熱狂的なマニア、推しには金を惜しまない',
    appearance: '太った中年、汗っかき、興奮すると顔が赤い',
    aiDifficulty: 'hard',  // 熱狂的だが計算は普通
    quotes: {
      win: 'やっぱり岩狸は最高なんだよ！',
      lose: 'く...でも俺の愛は本物だ！',
      start: '岩狸の強さを見せてやる！',
    },
    decks: ['熔岩の王国', '無限増殖'],
  },

  liliane: {
    id: 'liliane',
    name: 'リリアーヌ',
    attribute: '闇/光',
    portrait: '👗',
    style: 'コレクター',
    personality: 'わがままだが目利き、かわいいもの狂い',
    appearance: 'フリル服のお嬢様、巻き髪、日傘',
    aiDifficulty: 'hard',  // わがままだが目利き
    quotes: {
      win: '当然の結果ですわ',
      lose: 'こんなの認めませんわ！',
      start: 'かわいいは正義ですの',
    },
    decks: ['幼魔王女の支配', '黒呪の魔女'],
  },

  galdos: {
    id: 'galdos',
    name: 'ガルドス',
    attribute: '炎/光',
    portrait: '🗡️',
    style: 'コレクター',
    personality: '武勇伝を語りたがる、根は優しい',
    appearance: '傷だらけの筋肉爺、元冒険者、片目に眼帯',
    aiDifficulty: 'hard',  // 元冒険者の経験
    quotes: {
      win: 'ワシの時代はまだ終わらんのじゃ',
      lose: 'ぐぬぬ...若さには勝てんか',
      start: 'かつてドラゴンと戦った男の戦いを見せてやろう',
    },
    decks: ['紅蓮龍炎', '不死鳥フェニックス'],
  },

  misty: {
    id: 'misty',
    name: 'ミスティ',
    attribute: '水',
    portrait: '🐱',
    style: 'コレクター',
    personality: '猫にしか興味ない、人間には塩対応',
    appearance: '猫耳フードの女性、無表情、目だけ動く',
    aiDifficulty: 'hard',  // コントロール系の高度なプレイ
    quotes: {
      win: '...猫の勝ち',
      lose: '...次は負けない',
      start: '...始めるよ',
    },
    decks: ['氷眠の檻', '氷猫の狩人'],
  },

  profNome: {
    id: 'profNome',
    name: 'プロフ・ノーム',
    attribute: '未来',
    portrait: '📚',
    style: 'コレクター',
    personality: '分析オタク、人の話聞かない',
    appearance: '曇った眼鏡、よれた白衣、常にメモ帳',
    aiDifficulty: 'hard',  // 分析オタクの緻密なプレイ
    quotes: {
      win: 'データ通りの結果と言えますね',
      lose: '興味深い...分析し直す必要がありますね',
      start: 'さて、実験開始といきましょうか',
    },
    decks: ['魔導遺跡の守護者', '紫鴉の預言者'],
  },

  sisterEmma: {
    id: 'sisterEmma',
    name: 'シスター・エマ',
    attribute: '光',
    portrait: '🕊️',
    style: 'コレクター',
    personality: '穏やかで優しい、たまに天然',
    appearance: '修道服、柔らかい笑顔、小鳥が肩に',
    aiDifficulty: 'hard',  // 穏やか、天然
    quotes: {
      win: '神のご加護がありました',
      lose: 'これも試練ですね...',
      start: '平和的に参りましょう',
    },
    decks: ['聖なる巨鳥', '果実の人形劇'],
  },

  // ドッペルゲンガー（プレイヤーのデッキを使用）
  doppelganger: {
    id: 'doppelganger',
    name: 'ドッペルゲンガー',
    attribute: 'なし',
    portrait: '🎭',
    style: '模倣',
    personality: '無言、不気味、プレイヤーの動きをコピー',
    appearance: '黒い霧のような姿、時折プレイヤーの姿に変わる',
    aiDifficulty: 'hard',  // プレイヤーの影
    quotes: {
      win: '...（あなたの声で笑う）',
      lose: '...（霧となって消える）',
      start: '...（あなたを見つめている）',
    },
    decks: ['プレイヤーコピー'],  // 特殊デッキ：プレイヤーのデッキを使用
  },
};

// ============================================================
// デッキ定義
// ============================================================

export const DECKS = {
  // デッキ1: 深海の支配者（氷姫セイラ）
  '深海の支配者': {
    name: '深海の支配者',
    owner: 'seira',
    attribute: '水',
    type: 'コントロール/バーン',
    concept: '漂流民と深海の使者の融合。【魂結】でモンスター強化、フェイズカードでバフとバーン。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000331', count: 3 },  // アクアレギナの漂流船乗り
      { id: 'C0000330', count: 3 },  // アクアレギナの漂流漁師
      { id: 'C0000334', count: 3 },  // ヴェルゼファールの眷属・クラディオム
      { id: 'C0000332', count: 3 },  // アクアレギナの守護者
      { id: 'C0000333', count: 3 },  // ヴェルゼファールの信徒・深みの儀式者
      { id: 'C0000335', count: 3 },  // ヴェルゼファールの眷属・シスラゴン
      { id: 'C0000336', count: 3 },  // ヴェルゼファールの眷属・ルミナクール
      { id: 'C0000337', count: 3 },  // ヴェルゼファールの眷属・タラッサロス
      { id: 'C0000340', count: 1 },  // 深海の支配者・ヴェルゼファール
      // 魔法（12枚）
      { id: 'C0000341', count: 3 },  // ヴェルゼファール降臨の儀式
      { id: 'C0000342', count: 2 },  // 漂流民の抵抗
      { id: 'C0000343', count: 2 },  // アクアレギナの水晶術師の防壁
      { id: 'C0000344', count: 2 },  // シスラゴンの汚染
      // フィールド（3枚）
      { id: 'C0000338', count: 3 },  // アクアレギアの廃墟
      // フェイズカード（3枚）
      { id: 'C0000339', count: 3 },  // アクアレギナの動力-エテルノス・コア
    ],
  },

  // デッキ2: 熔岩の王国（ピッポ）
  '熔岩の王国': {
    name: '熔岩の王国',
    owner: 'pippo',
    attribute: '炎',
    type: 'ビート/バーン',
    concept: '岩狸モンスターの【マグマフォージ】シナジー。大岩王の超火力とバーン。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000163', count: 3 },  // 岩狸・石ころ丸
      { id: 'C0000164', count: 3 },  // 岩狸・岩太
      { id: 'C0000165', count: 3 },  // 岩狸・熔岩守
      { id: 'C0000166', count: 3 },  // 岩狸・地割れ狸
      { id: 'C0000167', count: 3 },  // 岩狸・剛石権蔵
      { id: 'C0000169', count: 3 },  // 岩狸・火山頭
      { id: 'C0000170', count: 3 },  // 岩狸・大岩王
      { id: 'C0000171', count: 2 },  // 岩狸・熔岩権蔵・極
      { id: 'C0000172', count: 1 },  // 岩狸・禁忌の熔岩帝
      // 魔法（10枚）
      { id: 'C0000173', count: 3 },  // 熔岩の呼び声
      { id: 'C0000174', count: 3 },  // 岩狸の咆哮
      { id: 'C0000179', count: 2 },  // 熔岩再生
      { id: 'C0000184', count: 2 },  // 狸の業火
      // フィールド（3枚）
      { id: 'C0000187', count: 3 },  // 狸の熔岩郷
      // フェイズカード（3枚）
      { id: 'C0000185', count: 3 },  // 岩狸の山里
    ],
  },

  // デッキ3: 紫鴉の預言者（機工士ノヴァ）
  '紫鴉の預言者': {
    name: '紫鴉の預言者',
    owner: 'nova',
    attribute: '未来',
    type: 'コントロール',
    concept: 'ミランと未来鴉でデッキトップ操作と手札破壊。禁忌の鴉王ミランで制圧。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000249', count: 3 },  // ミランの使い魔未来鴉
      { id: 'C0000250', count: 3 },  // 時空渡りのカモメ
      { id: 'C0000256', count: 3 },  // 紫時空の幻鴉
      { id: 'C0000265', count: 2 },  // 鴉の幻影
      { id: 'C0000252', count: 3 },  // 未来鴉の群れ
      { id: 'C0000251', count: 3 },  // 紫鴉の魔導士ミラン
      { id: 'C0000267', count: 2 },  // 星翼の飛舟エクラオン
      { id: 'C0000260', count: 2 },  // 預言者モナビン
      { id: 'C0000258', count: 1 },  // 禁忌の鴉王ミラン
      // 魔法（12枚）
      { id: 'C0000255', count: 3 },  // 未来の鴉予言
      { id: 'C0000253', count: 3 },  // 未来の紫翼
      { id: 'C0000254', count: 2 },  // 時の歪曲
      { id: 'C0000262', count: 2 },  // 時の遅延
      { id: 'C0000269', count: 2 },  // 永遠の灯の残響
      // フィールド（3枚）
      { id: 'C0000257', count: 3 },  // 時読みの塔
      // フェイズカード（3枚）
      { id: 'C0000266', count: 3 },  // エクラシアの時空炉
    ],
  },

  // デッキ4: 呪森の狩人（獣王ガロン）
  '呪森の狩人': {
    name: '呪森の狩人',
    owner: 'garon',
    attribute: '原始/水',
    type: 'ビート/バーン',
    concept: '狼・鹿・イノシシと黒涙の沼の怪物の融合。バーンで削りながらビート。',
    cards: [
      // モンスター（23枚）
      { id: 'C0000414', count: 3 },  // 呪縛の群狼
      { id: 'C0000416', count: 3 },  // 霧角の鹿ケルニグリス
      { id: 'C0000413', count: 3 },  // 群狼長ヴァルグレイス
      { id: 'C0000421', count: 3 },  // 沼の狩人クルーロプス
      { id: 'C0000404', count: 3 },  // 呪森の狼王グリムヴァルド
      { id: 'C0000415', count: 2 },  // 呪影の牙狼ウルフェイン
      { id: 'C0000423', count: 2 },  // 黒涙の毒樹フロラクルス
      { id: 'C0000417', count: 2 },  // 棘の剛毛猪イノブリスト
      { id: 'C0000403', count: 2 },  // 沼の血叫びヴォルガノス
      // 魔法（14枚）
      { id: 'C0000430', count: 3 },  // 狼王の咆哮
      { id: 'C0000432', count: 3 },  // 棘根の罠
      { id: 'C0000207', count: 2 },  // 知恵の代償
      { id: 'C0000195', count: 2 },  // 交換の手札
      { id: 'C0000194', count: 2 },  // 急ごしらえの罠
      { id: 'C0000198', count: 2 },  // 逆転の足音
      // フィールド（3枚）
      { id: 'C0000140', count: 3 },  // 鎖の迷宮
    ],
  },

  // デッキ5: 闇の預言者（謎の仮面）
  '闇の預言者': {
    name: '闇の預言者',
    owner: 'mask',
    attribute: '闇',
    type: 'コントロール/コンボ',
    concept: '禁忌の儀式でブラック・オラクル召喚、召喚時3000全体ダメージ。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000115', count: 3 },  // 禁断の使徒
      { id: 'C0000082', count: 2 },  // 怨霊の使者
      { id: 'C0000076', count: 3 },  // シャドウ・サーバント
      { id: 'C0000079', count: 3 },  // 深淵の騎士ガルム
      { id: 'C0000111', count: 3 },  // 禁忌の守護者
      { id: 'C0000078', count: 2 },  // 禁忌の傀儡師マレウス
      { id: 'C0000080', count: 2 },  // 闇魔界の貴婦人
      { id: 'C0000110', count: 2 },  // 闇の支配者
      { id: 'C0000420', count: 1 },  // 瘴気の蟻アラクノファグス
      { id: 'C0000109', count: 1 },  // ブラック・オラクル
      // 魔法（12枚）
      { id: 'C0000083', count: 3 },  // 闇の契約
      { id: 'C0000103', count: 3 },  // 奈落の呼び声
      { id: 'C0000120', count: 2 },  // 禁忌の儀式
      { id: 'C0000117', count: 2 },  // 禁忌の波動
      { id: 'C0000086', count: 2 },  // 闇の波動
      // フィールド（4枚）
      { id: 'C0000089', count: 2 },  // 闇の宮殿
      { id: 'C0000123', count: 2 },  // 禁忌の王座
      // フェイズカード（2枚）
      { id: 'C0000108', count: 2 },  // 虚蝕の呪詛
    ],
  },

  // デッキ6: 死の女神（闇術師マリク）
  '死の女神': {
    name: '死の女神',
    owner: 'malik',
    attribute: '闇',
    type: 'バーン/ビート',
    concept: 'ネクロフィアの毎ターン全体500バーン。低コスト闇属性を並べてバーンとビート。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000115', count: 3 },  // 禁断の使徒
      { id: 'C0000082', count: 3 },  // 怨霊の使者
      { id: 'C0000282', count: 3 },  // 暗殺者の亡魂
      { id: 'C0000076', count: 3 },  // シャドウ・サーバント
      { id: 'C0000079', count: 3 },  // 深淵の騎士ガルム
      { id: 'C0000077', count: 2 },  // 彷徨える死者
      { id: 'C0000078', count: 3 },  // 禁忌の傀儡師マレウス
      { id: 'C0000080', count: 2 },  // 闇魔界の貴婦人
      { id: 'C0000074', count: 2 },  // ダーク・ネクロフィア
      // 魔法（12枚）
      { id: 'C0000083', count: 3 },  // 闇の契約
      { id: 'C0000088', count: 3 },  // ネクロフィアの儀式
      { id: 'C0000103', count: 3 },  // 奈落の呼び声
      { id: 'C0000086', count: 3 },  // 闇の波動
      // フィールド（2枚）
      { id: 'C0000089', count: 2 },  // 闇の宮殿
      // フェイズカード（2枚）
      { id: 'C0000108', count: 2 },  // 虚蝕の呪詛
    ],
  },

  // デッキ7: 雷帝の裁き（聖騎士ロウェン）
  '雷帝の裁き': {
    name: '雷帝の裁き',
    owner: 'rowen',
    attribute: '光',
    type: 'ビート/コントロール',
    concept: '雷撃状態でコントロールしながら、雷帝と雷嵐龍でフィニッシュ。',
    cards: [
      // モンスター（23枚）
      { id: 'C0000328', count: 3 },  // 雷鳴の斥候
      { id: 'C0000322', count: 3 },  // 嵐の雛雷鳥
      { id: 'C0000318', count: 3 },  // 雷鳴の使者
      { id: 'C0000329', count: 3 },  // 嵐の雷撃獣
      { id: 'C0000321', count: 3 },  // 電刃の執行者
      { id: 'C0000319', count: 3 },  // 嵐光の騎士
      { id: 'C0000320', count: 3 },  // 雷帝ヴォルトロン
      { id: 'C0000327', count: 2 },  // 雷嵐龍サンダーストーム・レックス
      // 魔法（11枚）
      { id: 'C0000323', count: 3 },  // 雷鳴の裁き
      { id: 'C0000324', count: 3 },  // 嵐の咆哮
      { id: 'C0000065', count: 3 },  // 天使の波動
      { id: 'C0000068', count: 2 },  // クリスタルブレス
      // フィールド（6枚）
      { id: 'C0000326', count: 3 },  // 雷嵐の聖域
      { id: 'C0000073', count: 3 },  // 輝く天蓋
    ],
  },

  // デッキ8: プニリーヌの騎士団（新人トーマ）
  'プニリーヌの騎士団': {
    name: 'プニリーヌの騎士団',
    owner: 'toma',
    attribute: 'なし',
    type: 'スワーム/ビート',
    concept: '蛮族を大量展開し、禁忌の奴隷プニリーヌで蛮族数×600の大ダメージ。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000223', count: 3 },  // 鉄槍騎士団のゴロツキ
      { id: 'C0000302', count: 3 },  // 鉄槍のソルジャー
      { id: 'C0000303', count: 3 },  // 鉄槍のソルジャーII
      { id: 'C0000222', count: 3 },  // 鉄槍騎士団のウィア
      { id: 'C0000221', count: 3 },  // 鉄槍騎士団のマグラ
      { id: 'C0000219', count: 3 },  // 団長プニリーヌ・ソフティア
      { id: 'C0000317', count: 2 },  // 鉄槍の騎士長
      { id: 'C0000220', count: 3 },  // 鉄槍騎士団のゲスール
      { id: 'C0000224', count: 1 },  // 鉄槍騎士団の奴隷プニリーヌ
      // 魔法（13枚）
      { id: 'C0000225', count: 3 },  // 鉄槍の奉仕
      { id: 'C0000226', count: 3 },  // 順番待ちの苛立ち
      { id: 'C0000227', count: 2 },  // 鉄槍の昼餐
      { id: 'C0000228', count: 2 },  // 鉄槍の睡眠罠
      { id: 'C0000196', count: 3 },  // 援軍の呼び声
      // フィールド（3枚）
      { id: 'C0000229', count: 3 },  // 鉄槍騎士団の宿舎
    ],
  },

  // デッキ9: 幼魔王女の支配（氷姫セイラ）
  '幼魔王女の支配': {
    name: '幼魔王女の支配',
    owner: 'seira',
    attribute: '混合',
    type: 'コントロール',
    concept: 'ゴシック・リリカ軸。幼魔王女でサーチ、ご主人様でリリカ展開＆強化。',
    cards: [
      // モンスター（25枚）
      { id: 'C0000132', count: 3 },  // ゴシック・パペット
      { id: 'C0000127', count: 3 },  // ゴシック・ローズ
      { id: 'C0000233', count: 3 },  // 水漏れのリリカ
      { id: 'C0000232', count: 3 },  // 奉仕のリリカ
      { id: 'C0000128', count: 3 },  // 鎖縛のメイド
      { id: 'C0000235', count: 2 },  // プリンセス狂いのリリカ
      { id: 'C0000125', count: 2 },  // ゴシック・ドール
      { id: 'C0000129', count: 2 },  // ゴシック・プリンセス
      { id: 'C0000234', count: 2 },  // 撮影会のリリカ
      { id: 'C0000231', count: 2 },  // 幼魔王女リリカ
      { id: 'C0000241', count: 2 },  // ご主人様
      { id: 'C0000138', count: 1 },  // 禁忌のゴシッククラウン
      // 魔法（12枚）
      { id: 'C0000238', count: 3 },  // おしおきの鎖
      { id: 'C0000236', count: 3 },  // プリティ☆プリンセス
      { id: 'C0000237', count: 2 },  // 幼魔王女の誘惑
      { id: 'C0000243', count: 2 },  // ご主人様のおしおき
      { id: 'C0000133', count: 2 },  // 鎖の舞踏
      // フィールド（3枚）
      { id: 'C0000240', count: 3 },  // 魔界の幼魔王城
    ],
  },

  // デッキ10: 紅蓮の咆哮（炎帝カイン）
  '紅蓮の咆哮': {
    name: '紅蓮の咆哮',
    owner: 'kain',
    attribute: '炎',
    type: 'アグロ/バーン',
    concept: 'ブレイズ・ドラゴンでサーチ、ドラゴンの火山でバフとバーン。炎ドラゴンアグロ。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000025', count: 3 },  // ブレイズ・ドラゴン
      { id: 'C0000029', count: 3 },  // クリムゾン・ワイバーン
      { id: 'C0000021', count: 3 },  // フレア・ドラゴン
      { id: 'C0000026', count: 3 },  // インフェルノ・ドラゴン
      { id: 'C0000027', count: 3 },  // マグマ・ドラゴン
      { id: 'C0000030', count: 3 },  // バースト・ドラゴン・ナイト
      { id: 'C0000023', count: 3 },  // レッドバーストドラゴン
      { id: 'C0000028', count: 1 },  // 炎竜母フレイマ
      // 魔法（12枚）
      { id: 'C0000022', count: 3 },  // 火竜の吐息
      { id: 'C0000031', count: 3 },  // 炎の咆哮
      { id: 'C0000033', count: 3 },  // 紅蓮の覚醒
      { id: 'C0000034', count: 3 },  // 炎の嵐
      // フィールド（6枚）
      { id: 'C0000037', count: 3 },  // ドラゴンの火山
      { id: 'C0000038', count: 3 },  // 紅の竜宮
    ],
  },

  // デッキ11: 血炎の呪い（炎帝カイン）
  '血炎の呪い': {
    name: '血炎の呪い',
    owner: 'kain',
    attribute: '炎',
    type: 'ビート/バーン',
    concept: '血炎系モンスターで墓地肥やしと攻撃時バフ。炎の岩峰でバーン。',
    cards: [
      // モンスター（23枚）
      { id: 'C0000292', count: 3 },  // 炎のソルジャー
      { id: 'C0000293', count: 3 },  // 炎のソルジャーII
      { id: 'C0000412', count: 3 },  // 血針の蠍スコーピグニス
      { id: 'C0000369', count: 3 },  // 炎翼の鳥民・イグニス
      { id: 'C0000168', count: 3 },  // 熱き剣士セイニー
      { id: 'C0000411', count: 3 },  // 呪炎殻のイグニファトゥス
      { id: 'C0000406', count: 3 },  // 血炎の精霊ブラッドフェニクス
      { id: 'C0000410', count: 2 },  // 峠の暴君ヴェルミグノス
      // 魔法（14枚）
      { id: 'C0000175', count: 3 },  // 地層の炎流
      { id: 'C0000176', count: 3 },  // 熔岩の罠
      { id: 'C0000428', count: 3 },  // 血焔の嵐
      { id: 'C0000160', count: 3 },  // 業火の爆炎
      { id: 'C0000177', count: 2 },  // 岩石の守護
      // フィールド（3枚）
      { id: 'C0000188', count: 3 },  // 炎の岩峰
    ],
  },

  // デッキ12: 密林の小さな命（新人トーマ）
  '密林の小さな命': {
    name: '密林の小さな命',
    owner: 'toma',
    attribute: '混合',
    type: 'スワーム/ランプ',
    concept: '低コスト虹羽密林モンスターを大量展開。',
    cards: [
      // モンスター（28枚）
      { id: 'C0000377', count: 3 },  // 虹羽密林の赤花蔓・カルティノス
      { id: 'C0000379', count: 3 },  // 虹羽密林の青滴虫・サルフィス
      { id: 'C0000375', count: 3 },  // 虹羽密林の霧花蛙・ヴェルミナ
      { id: 'C0000378', count: 3 },  // 虹羽密林の金胞草・ファルネシア
      { id: 'C0000373', count: 3 },  // 虹羽密林の血針蟻・ザルヴァキス
      { id: 'C0000374', count: 3 },  // 虹羽密林の輝甲虫・ルクセリオ
      { id: 'C0000380', count: 3 },  // 虹羽密林の湖鱗獣・アクアレオン
      { id: 'C0000361', count: 3 },  // 虹羽密林のフェザートラップ
      { id: 'C0000363', count: 2 },  // 虹羽密林のアクアフェザー
      { id: 'C0000042', count: 2 },  // 潮の乙女
      // 魔法（6枚）
      { id: 'C0000381', count: 3 },  // 虹羽密林の生命網
      { id: 'C0000362', count: 3 },  // 風鳴樹
      // フィールド（3枚）
      { id: 'C0000376', count: 3 },  // 虹羽の微脈
      // フェイズカード（3枚）
      { id: 'C0000383', count: 3 },  // 虹羽密林の共鳴弦
    ],
  },

  // デッキ13: 聖なる巨鳥（森の賢者エルダ）
  '聖なる巨鳥': {
    name: '聖なる巨鳥',
    owner: 'elda',
    attribute: '光',
    type: 'ミッドレンジ',
    concept: '鳥民サーチとコスト軽減。ファルクェス・アルディオンの壮麗効果でフィニッシュ。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000356', count: 3 },  // 鳥民の斥候・ヴェルティス
      { id: 'C0000357', count: 3 },  // 風刻の使者・シルヴァリス
      { id: 'C0000347', count: 3 },  // 鳥民の供物者・カルディス
      { id: 'C0000368', count: 3 },  // 裁定の鳥民・ミナルス
      { id: 'C0000354', count: 3 },  // 鳥民の風使い・ゼルヴィス
      { id: 'C0000346', count: 3 },  // ヴォランティス・セラヴェント
      { id: 'C0000348', count: 2 },  // ヴォランティス・ファルクェス
      { id: 'C0000345', count: 2 },  // ヴォランティス・アルディオン
      // 魔法（12枚）
      { id: 'C0000358', count: 3 },  // アヴィクルスの風鳴り
      { id: 'C0000350', count: 3 },  // 鳥民の祈り
      { id: 'C0000355', count: 3 },  // 鳥民の壮麗儀式
      { id: 'C0000349', count: 3 },  // アヴィクルスの裁定
      // フィールド（3枚）
      { id: 'C0000351', count: 3 },  // 天翔峰アヴィクルス
      // フェイズカード（3枚）
      { id: 'C0000352', count: 3 },  // アヴィクルスの試練
    ],
  },

  // デッキ14: 天翔の覇王（森の賢者エルダ）
  '天翔の覇王': {
    name: '天翔の覇王',
    owner: 'elda',
    attribute: '混合',
    type: 'ランプ/コントロール',
    concept: '多属性鳥民展開。犠現でコスト軽減、エテルノス(3800/4800)で制圧。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000356', count: 3 },  // 鳥民の斥候・ヴェルティス
      { id: 'C0000347', count: 3 },  // 鳥民の供物者・カルディス
      { id: 'C0000357', count: 3 },  // 風刻の使者・シルヴァリス
      { id: 'C0000368', count: 2 },  // 裁定の鳥民・ミナルス
      { id: 'C0000370', count: 3 },  // 影羽の鳥民・ノクティス
      { id: 'C0000371', count: 3 },  // 風詠の鳥民・ゼフィラス
      { id: 'C0000346', count: 2 },  // ヴォランティス・セラヴェント
      { id: 'C0000364', count: 2 },  // ヴォランティス・エクリプス
      { id: 'C0000360', count: 2 },  // ヴォランティス・テンペスト
      { id: 'C0000353', count: 1 },  // ヴォランティス・エテルノス
      // 魔法（10枚）
      { id: 'C0000358', count: 3 },  // アヴィクルスの風鳴り
      { id: 'C0000350', count: 3 },  // 鳥民の祈り
      { id: 'C0000355', count: 2 },  // 鳥民の壮麗儀式
      { id: 'C0000382', count: 2 },  // 虹羽の覚醒脈
      // フィールド（6枚）
      { id: 'C0000366', count: 3 },  // 天翔秘島
      { id: 'C0000351', count: 3 },  // 天翔峰アヴィクルス
    ],
  },

  // デッキ15: 密林の覚醒（獣王ガロン）
  '密林の覚醒': {
    name: '密林の覚醒',
    owner: 'garon',
    attribute: '混合',
    type: 'コンボ/ワンショット',
    concept: '虹羽の覚醒脈でヴォランティスをコスト無視召喚。オーブで攻撃力+2500、一撃必殺。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000377', count: 3 },  // 虹羽密林の赤花蔓・カルティノス
      { id: 'C0000379', count: 3 },  // 虹羽密林の青滴虫・サルフィス
      { id: 'C0000378', count: 3 },  // 虹羽密林の金胞草・ファルネシア
      { id: 'C0000373', count: 3 },  // 虹羽密林の血針蟻・ザルヴァキス
      { id: 'C0000374', count: 3 },  // 虹羽密林の輝甲虫・ルクセリオ
      { id: 'C0000359', count: 2 },  // ヴォランティス・インフェルノ
      { id: 'C0000345', count: 2 },  // ヴォランティス・アルディオン
      { id: 'C0000364', count: 2 },  // ヴォランティス・エクリプス
      { id: 'C0000353', count: 1 },  // ヴォランティス・エテルノス
      // 魔法（12枚）
      { id: 'C0000382', count: 3 },  // 虹羽の覚醒脈
      { id: 'C0000381', count: 3 },  // 虹羽密林の生命網
      { id: 'C0000365', count: 3 },  // ヴォランティス・オーブ
      { id: 'C0000207', count: 3 },  // 知恵の代償
      // フィールド（6枚）
      { id: 'C0000366', count: 3 },  // 天翔秘島
      { id: 'C0000376', count: 3 },  // 虹羽の微脈
    ],
  },

  // デッキ16: 果実の人形劇（森の賢者エルダ）
  '果実の人形劇': {
    name: '果実の人形劇',
    owner: 'elda',
    attribute: '光',
    type: 'ミッドレンジ/コントロール',
    concept: 'フルーツ・マリオネットで墓地肥やし＆回復。コントロール奪取でフィニッシュ。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000211', count: 3 },  // フルーツ・マリオネット・アップル
      { id: 'C0000212', count: 3 },  // フルーツ・マリオネット・オレンジ
      { id: 'C0000213', count: 3 },  // フルーツ・マリオネット・バナナ
      { id: 'C0000214', count: 3 },  // フルーツ・マリオネット・グレープ
      { id: 'C0000215', count: 3 },  // フルーツ・マリオネット・メロン王
      { id: 'C0000362', count: 3 },  // 風鳴樹
      { id: 'C0000378', count: 3 },  // 金胞草・ファルネシア
      { id: 'C0000091', count: 3 },  // 灯火の精霊
      // 魔法（10枚）
      { id: 'C0000216', count: 3 },  // フルーツの糸引き
      { id: 'C0000217', count: 3 },  // 光果の舞踏
      { id: 'C0000065', count: 2 },  // 天使の波動
      { id: 'C0000068', count: 2 },  // クリスタルブレス
      // フィールド（6枚）
      { id: 'C0000218', count: 3 },  // フルーツ・マリオネット劇場
      { id: 'C0000073', count: 3 },  // 輝く天蓋
    ],
  },

  // デッキ17: 闇鎖の舞踏（闇術師マリク）
  '闇鎖の舞踏': {
    name: '闇鎖の舞踏',
    owner: 'malik',
    attribute: '原始',
    type: 'コントロール',
    concept: 'ゴシック・鎖で相手を拘束。禁忌の檻でゴシック数×300バーン。',
    cards: [
      // モンスター（23枚）
      { id: 'C0000132', count: 3 },  // ゴシック・パペット
      { id: 'C0000127', count: 3 },  // ゴシック・ローズ
      { id: 'C0000128', count: 3 },  // 鎖縛のメイド
      { id: 'C0000131', count: 3 },  // 鎖の守護者
      { id: 'C0000125', count: 2 },  // ゴシック・ドール
      { id: 'C0000129', count: 3 },  // ゴシック・プリンセス
      { id: 'C0000231', count: 2 },  // 幼魔王女リリカ
      { id: 'C0000244', count: 2 },  // 鎖縛の幻姫リアノン
      { id: 'C0000138', count: 2 },  // 禁忌のゴシッククラウン
      // 魔法（11枚）
      { id: 'C0000238', count: 3 },  // おしおきの鎖
      { id: 'C0000133', count: 3 },  // 鎖の舞踏
      { id: 'C0000136', count: 2 },  // 鎖の呪縛
      { id: 'C0000134', count: 3 },  // ゴシックの誘惑
      // フィールド（6枚）
      { id: 'C0000139', count: 3 },  // ゴシック・フォートレス
      { id: 'C0000141', count: 3 },  // 禁忌の檻
    ],
  },

  // デッキ18: 聖域の光（聖騎士ロウェン）
  '聖域の光': {
    name: '聖域の光',
    owner: 'rowen',
    attribute: '光',
    type: 'ミッドレンジ',
    concept: '光属性サポートと破壊耐性。ルシフェリエルで回復＆フィニッシュ。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000121', count: 3 },  // 聖域の灯守兵
      { id: 'C0000091', count: 3 },  // 灯火の精霊
      { id: 'C0000020', count: 3 },  // 灯火の護衛霊
      { id: 'C0000122', count: 3 },  // 聖域の戦士
      { id: 'C0000057', count: 3 },  // プリズム・ガーディアン
      { id: 'C0000060', count: 2 },  // 聖なる導師
      { id: 'C0000056', count: 3 },  // 輝聖女ルミナス
      { id: 'C0000058', count: 2 },  // 熾天使セラフ
      { id: 'C0000162', count: 2 },  // 死神天使ルシフェリエル
      // 魔法（10枚）
      { id: 'C0000065', count: 3 },  // 天使の波動
      { id: 'C0000066', count: 3 },  // ホーリーライトサモン
      { id: 'C0000064', count: 2 },  // ルミナスの裁き
      { id: 'C0000158', count: 2 },  // 聖光の刃
      // フィールド（6枚）
      { id: 'C0000072', count: 3 },  // ルミナスの聖域
      { id: 'C0000073', count: 3 },  // 輝く天蓋
    ],
  },

  // ============================================================
  // コレクター用デッキ
  // ============================================================

  // デッキ19: 無限増殖（ピッポ）- 粘液獣スウォーム
  '無限増殖': {
    name: '無限増殖',
    owner: 'pippo',
    attribute: '原始',
    type: 'スウォーム',
    concept: '粘液獣の分裂・増殖で大量展開し、キングの「1体につきATK+1500」で超火力フィニッシャー。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000008', count: 3 },  // 粘液獣・胞子
      { id: 'C0000001', count: 3 },  // 粘液獣・開花
      { id: 'C0000009', count: 3 },  // 粘液獣・寄生
      { id: 'C0000304', count: 3 },  // 粘液獣・幼体
      { id: 'C0000004', count: 3 },  // ゴミあさり粘液獣
      { id: 'C0000002', count: 1 },  // 触覚持ち粘液獣
      { id: 'C0000005', count: 2 },  // 苗床粘液獣
      { id: 'C0000010', count: 2 },  // 粘液獣・融合体
      { id: 'C0000006', count: 2 },  // 新・超覚醒粘液獣ハイパー
      { id: 'C0000011', count: 1 },  // 粘液獣・暴走体
      { id: 'C0000007', count: 2 },  // 粘液獣・キング
      // 魔法（13枚）
      { id: 'C0000012', count: 3 },  // 粘液の増殖
      { id: 'C0000013', count: 2 },  // 粘液の罠
      { id: 'C0000014', count: 2 },  // 粘液再生
      { id: 'C0000015', count: 1 },  // 粘液の浸食
      { id: 'C0000016', count: 2 },  // 粘液爆発
      { id: 'C0000017', count: 2 },  // 未来の粘液回路
      // フィールド（3枚）
      { id: 'C0000003', count: 3 },  // 粘液獣の群生地

    ],
  },

  // デッキ20: 黒呪の魔女（リリアーヌ）- エリザヴェット軸
  '黒呪の魔女': {
    name: '黒呪の魔女',
    owner: 'liliane',
    attribute: '闇',
    type: 'コントロール',
    concept: 'エリザヴェット・ヴェイルと黒呪魔法のコスト軽減で相手を蝕むコントロール。呪骸王の500バーンで削り切る。',
    cards: [
      // モンスター（18枚）
      { id: 'C0000385', count: 3 },  // 呪魂の従者
      { id: 'C0000427', count: 3 },  // 灰塵の骨霊ファントマリス
      { id: 'C0000407', count: 3 },  // 魂喰いのレイスヴィット
      { id: 'C0000384', count: 3 },  // 魔女エリザヴェット・ヴェイル
      { id: 'C0000418', count: 1 },  // 深層の隠蟲クリプトノムス
      { id: 'C0000424', count: 2 },  // 呪灰の翼ダスクドラゴン
      { id: 'C0000396', count: 2 },  // 呪骸王エリザルヴェドン
      { id: 'C0000425', count: 1 },  // 灰骨竜フレアスケルス
      // 魔法（18枚）
      { id: 'C0000388', count: 3 },  // 黒呪・ファルザノンの影爪
      { id: 'C0000389', count: 3 },  // 黒呪・ザルガノートの呪鎖
      { id: 'C0000390', count: 3 },  // 黒呪・ヴェルザクトの黒刃
      { id: 'C0000391', count: 2 },  // 黒呪・トゥルヴァントの障壁
      { id: 'C0000392', count: 2 },  // 黒呪・ドルヴァネクの傀儡糸
      { id: 'C0000393', count: 2 },  // 黒呪・カルヴェリオンの灰嵐
      { id: 'C0000394', count: 2 },  // 黒呪・エルザフィールの契約
      { id: 'C0000075', count: 1 },  // シャドウ・バインド
      // フィールド（2枚）
      { id: 'C0000386', count: 2 },  // 呪縛の塔・ヴェルナクール
      // フェイズカード（2枚）
      { id: 'C0000387', count: 2 },  // 呪核の杖・ザルヴェリオ
    ],
  },

  // デッキ21: 紅蓮龍炎（ガルドス）- 炎ドラゴンアグロ
  '紅蓮龍炎': {
    name: '紅蓮龍炎',
    owner: 'galdos',
    attribute: '炎',
    type: 'アグロ/バーン',
    concept: '炎ドラゴンの圧倒的なコスト効率とバーンダメージで4〜6ターンで削り切る超攻撃型。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000025', count: 3 },  // ブレイズ・ドラゴン
      { id: 'C0000369', count: 3 },  // 炎翼の鳥民・イグニス
      { id: 'C0000021', count: 3 },  // フレア・ドラゴン
      { id: 'C0000026', count: 3 },  // インフェルノ・ドラゴン
      { id: 'C0000029', count: 3 },  // クリムゾン・ワイバーン
      { id: 'C0000027', count: 2 },  // マグマ・ドラゴン
      { id: 'C0000030', count: 2 },  // バースト・ドラゴン・ナイト
      { id: 'C0000312', count: 1 },  // フレア・ワイバーン
      { id: 'C0000023', count: 2 },  // レッドバーストドラゴン
      { id: 'C0000028', count: 2 },  // 炎竜母フレイマ
      // 魔法（14枚）
      { id: 'C0000033', count: 2 },  // 紅蓮の覚醒
      { id: 'C0000022', count: 3 },  // 火竜の吐息
      { id: 'C0000031', count: 3 },  // 炎の咆哮
      { id: 'C0000032', count: 2 },  // ドラゴンの炎息
      { id: 'C0000034', count: 2 },  // 炎の嵐
      { id: 'C0000036', count: 2 },  // 燃え尽きる業火
      // フィールド（2枚）
      { id: 'C0000037', count: 2 },  // ドラゴンの火山
    ],
  },

  // デッキ22: 不死鳥フェニックス（ガルドス）- フェニックス復活型
  '不死鳥フェニックス': {
    name: '不死鳥フェニックス',
    owner: 'galdos',
    attribute: '光',
    type: 'ミッドレンジ/復活',
    concept: 'フェニックスの「復活」能力を軸に、破壊されても蘇る不屈の戦術。光属性サポートで打点を補い、粘り強く戦う。',
    cards: [
      // モンスター（23枚）
      { id: 'C0000062', count: 2 },  // 光の使徒
      { id: 'C0000121', count: 2 },  // 聖域の灯守兵
      { id: 'C0000020', count: 2 },  // 灯火の護衛霊
      { id: 'C0000059', count: 3 },  // 光の騎士
      { id: 'C0000091', count: 2 },  // 灯火の精霊
      { id: 'C0000057', count: 3 },  // プリズム・ガーディアン
      { id: 'C0000318', count: 1 },  // 雷鳴の使者
      { id: 'C0000346', count: 2 },  // ヴォランティス・セラヴェント
      { id: 'C0000063', count: 2 },  // 聖獣フェニックス
      { id: 'C0000314', count: 2 },  // 聖光フェニックス
      { id: 'C0000248', count: 1 },  // 輝鎖の聖姫ルミリア
      { id: 'C0000162', count: 1 },  // 死神天使ルシフェリエル
      // 魔法（12枚）
      { id: 'C0000066', count: 3 },  // ホーリーライトサモン
      { id: 'C0000068', count: 1 },  // クリスタルブレス
      { id: 'C0000064', count: 2 },  // ルミナスの裁き
      { id: 'C0000323', count: 2 },  // 雷鳴の裁き
      { id: 'C0000065', count: 2 },  // 天使の波動
      { id: 'C0000325', count: 1 },  // 電光の浄化
      { id: 'C0000158', count: 1 },  // 聖光の刃
      // フィールド（5枚）
      { id: 'C0000071', count: 2 },  // クリスタルサンクチュアリ
      { id: 'C0000072', count: 2 },  // ルミナスの聖域
      { id: 'C0000073', count: 1 },  // 輝く天蓋
    ],
  },

  // デッキ23: 氷猫の狩人（ミスティ）- ブリザードキャット特化
  '氷猫の狩人': {
    name: '氷猫の狩人',
    owner: 'misty',
    attribute: '水',
    type: 'コントロール/凍結',
    concept: '凍結による行動妨害＋ブリザードキャットシナジーで制圧。エターナルをフィニッシャーとし、孤軍奮闘＋貫通で決める。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000143', count: 3 },  // 氷猫の使い魔
      { id: 'C0000046', count: 1 },  // 泡沫の精霊
      { id: 'C0000144', count: 3 },  // ブリザードキャット・フロスト
      { id: 'C0000042', count: 2 },  // 潮の乙女
      { id: 'C0000233', count: 1 },  // 水漏れのリリカ
      { id: 'C0000145', count: 3 },  // ブリザードキャット・スノウ
      { id: 'C0000044', count: 1 },  // 水晶のマーメイド
      { id: 'C0000142', count: 3 },  // ブリザードマスター
      { id: 'C0000147', count: 2 },  // ブリザードキャット・シャード
      { id: 'C0000199', count: 1 },  // ブリザードマスターの愛猫・ミスティ
      { id: 'C0000157', count: 2 },  // ブリザードキャット・エターナル
      // 魔法（12枚）
      { id: 'C0000150', count: 3 },  // 氷の吐息
      { id: 'C0000152', count: 2 },  // 氷猫の遊戯
      { id: 'C0000151', count: 3 },  // ブリザードの呼び声
      { id: 'C0000049', count: 1 },  // タイダルシフト
      { id: 'C0000051', count: 2 },  // リヴァイアサンの奔流
      { id: 'C0000154', count: 1 },  // ブリザードの覚醒
      // フィールド（6枚）
      { id: 'C0000155', count: 3 },  // 氷猫の聖域
      { id: 'C0000053', count: 2 },  // 母なる大海
      { id: 'C0000156', count: 1 },  // 凍結の猫森
    ],
  },

  // デッキ24: 氷眠の檻（ミスティ）- 凍結/眠りコントロール
  '氷眠の檻': {
    name: '氷眠の檻',
    owner: 'misty',
    attribute: '水',
    type: 'コントロール/状態異常',
    concept: '凍結/眠りで相手を完全に封じ込め、じわじわと削る上級者向けデッキ。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000046', count: 2 },  // 泡沫の精霊
      { id: 'C0000143', count: 1 },  // 氷猫の使い魔
      { id: 'C0000144', count: 3 },  // ブリザードキャット・フロスト
      { id: 'C0000042', count: 2 },  // 潮の乙女
      { id: 'C0000145', count: 3 },  // ブリザードキャット・スノウ
      { id: 'C0000039', count: 3 },  // アクア・メイデン
      { id: 'C0000148', count: 1 },  // 氷の双尾猫
      { id: 'C0000142', count: 2 },  // ブリザードマスター
      { id: 'C0000146', count: 2 },  // 氷結の守護猫
      { id: 'C0000147', count: 2 },  // ブリザードキャット・シャード
      { id: 'C0000157', count: 1 },  // ブリザードキャット・エターナル
      // 魔法（14枚）
      { id: 'C0000150', count: 3 },  // 氷の吐息
      { id: 'C0000288', count: 3 },  // 酸の霧
      { id: 'C0000344', count: 2 },  // シスラゴンの汚染
      { id: 'C0000402', count: 2 },  // 呪術狩りの封印鎖
      { id: 'C0000151', count: 1 },  // ブリザードの呼び声
      { id: 'C0000051', count: 2 },  // リヴァイアサンの奔流
      { id: 'C0000154', count: 1 },  // ブリザードの覚醒
      // フィールド（4枚）
      { id: 'C0000053', count: 2 },  // 母なる大海
      { id: 'C0000155', count: 2 },  // 氷猫の聖域
    ],
  },

  // デッキ25: 星灯のエクラシア（機工士ノヴァ）- 未来コンボ
  '星灯のエクラシア': {
    name: '星灯のエクラシア',
    owner: 'nova',
    attribute: '未来',
    type: 'コンボ',
    concept: 'エクラシアの時空炉を段階強化し、黄金の時姫でフィニッシュ。',
    cards: [
      // モンスター（24枚）
      { id: 'C0000085', count: 2 },  // 胡乱なドローン
      { id: 'C0000090', count: 1 },  // 時脈の観測者
      { id: 'C0000278', count: 3 },  // 灯守りの少女
      { id: 'C0000116', count: 2 },  // 時空旅人ソラリア
      { id: 'C0000105', count: 1 },  // 魔導炉の残骸獣
      { id: 'C0000280', count: 3 },  // 星灯の少女エクラリア
      { id: 'C0000106', count: 2 },  // 次元渡り・ヴォイドウォーカー
      { id: 'C0000256', count: 1 },  // 紫時空の幻鴉
      { id: 'C0000274', count: 2 },  // 星辰の魔導術師
      { id: 'C0000268', count: 2 },  // 虚蝕の魔導兵
      { id: 'C0000260', count: 1 },  // 預言者モナビン
      { id: 'C0000267', count: 2 },  // 星翼の飛舟エクラオン
      { id: 'C0000271', count: 2 },  // 黄金の時姫エクラリア
      // 魔法（12枚）
      { id: 'C0000277', count: 3 },  // 星屑の時導術
      { id: 'C0000255', count: 3 },  // 未来の鴉予言
      { id: 'C0000273', count: 2 },  // エクラリアの残影
      { id: 'C0000269', count: 2 },  // 永遠の灯の残響
      { id: 'C0000261', count: 1 },  // アクセラレート
      { id: 'C0000262', count: 1 },  // 時の遅延
      // フィールド（1枚）
      { id: 'C0000257', count: 1 },  // 時読みの塔
      // フェイズカード（3枚）
      { id: 'C0000266', count: 3 },  // エクラシアの時空炉
    ],
  },

  // デッキ26: 鎖縛のリアリス（氷姫セイラ）- 鎖コントロール
  '鎖縛のリアリス': {
    name: '鎖縛のリアリス',
    owner: 'seira',
    attribute: '水/原始',
    type: 'コントロール',
    concept: 'リアノン・リアリスの拘束コンボを軸に、水属性の妨害カードでコントロール。相手を縛りながらじわじわ削る。',
    cards: [
      // モンスター（22枚）
      { id: 'C0000046', count: 2 },  // 泡沫の精霊
      { id: 'C0000042', count: 3 },  // 潮の乙女
      { id: 'C0000245', count: 3 },  // 鎖の守護霊リアリス
      { id: 'C0000127', count: 2 },  // ゴシック・ローズ
      { id: 'C0000244', count: 3 },  // 鎖縛の幻姫リアノン
      { id: 'C0000399', count: 3 },  // 呪術狩りの鎖術師ミリア
      { id: 'C0000039', count: 2 },  // アクア・メイデン
      { id: 'C0000248', count: 2 },  // 輝鎖の聖姫ルミリア
      { id: 'C0000246', count: 2 },  // 鎖縛の禁忌姫リアノン・エターナル
      // 魔法（12枚）
      { id: 'C0000133', count: 3 },  // 鎖の舞踏
      { id: 'C0000238', count: 2 },  // おしおきの鎖
      { id: 'C0000247', count: 2 },  // 鎖の共鳴
      { id: 'C0000402', count: 3 },  // 呪術狩りの封印鎖
      { id: 'C0000050', count: 2 },  // クラーケンの呼び声
      // フィールド（6枚）
      { id: 'C0000140', count: 3 },  // 鎖の迷宮
      { id: 'C0000053', count: 3 },  // 母なる大海
    ],
  },

  // デッキ27: 魔導遺跡の守護者（プロフ・ノーム）- ゴーレム軸
  '魔導遺跡の守護者': {
    name: '魔導遺跡の守護者',
    owner: 'profNome',
    attribute: '未来',
    type: 'ビート/コントロール',
    concept: '魔導ゴーレムと未来鴉の融合。ヴォイドゲートの遺構で未来属性を強化し、守護/殲滅の魔導ゴーレムで制圧する重量級デッキ。',
    cards: [
      // モンスター（27枚）
      { id: 'C0000085', count: 3 },  // 胡乱なドローン
      { id: 'C0000105', count: 3 },  // 魔導炉の残骸獣
      { id: 'C0000249', count: 3 },  // ミランの使い魔未来鴉
      { id: 'C0000106', count: 3 },  // 次元渡り・ヴォイドウォーカー
      { id: 'C0000321', count: 2 },  // 電刃の執行者
      { id: 'C0000131', count: 3 },  // 鎖の守護者
      { id: 'C0000252', count: 2 },  // 未来鴉の群れ
      { id: 'C0000251', count: 2 },  // 紫鴉の魔導士ミラン
      { id: 'C0000114', count: 2 },  // 闇の巨像
      { id: 'C0000107', count: 2 },  // 守護の魔導ゴーレム
      { id: 'C0000183', count: 2 },  // 殲滅の魔導ゴーレム
      // 魔法（7枚）
      { id: 'C0000253', count: 3 },  // 未来の紫翼
      { id: 'C0000261', count: 2 },  // アクセラレート
      { id: 'C0000254', count: 2 },  // 時の歪曲
      // フィールド（6枚）
      { id: 'C0000257', count: 3 },  // 時読みの塔
      { id: 'C0000270', count: 3 },  // ヴォイドゲートの遺構
    ],
  },

  // デッキ27: ランダム（謎の仮面）- 特別処理
  'ランダム': {
    name: 'ランダム',
    owner: 'mask',
    attribute: '混合',
    type: 'ランダム',
    concept: '何を使うか分からない。予測不能の戦術。',
    cards: null,  // nullでランダム生成を示す
  },

  // デッキ27: プレイヤーコピー（ドッペルゲンガー）- 特別処理
  'プレイヤーコピー': {
    name: 'プレイヤーコピー',
    owner: 'doppelganger',
    attribute: '混合',
    type: 'コピー',
    concept: 'プレイヤーの保存デッキを使用。デッキがない場合はNPCのランダムデッキを使用。',
    cards: 'player',  // 'player'でプレイヤーデッキコピーを示す
  },
};

// ============================================================
// ヘルパー関数
// ============================================================

/**
 * NPCのデッキリストを取得
 * @param {string} competitorId - NPC ID
 * @returns {string[]} デッキ名の配列
 */
export function getCompetitorDeckNames(competitorId) {
  const competitor = COMPETITORS[competitorId];
  if (!competitor) return [];
  return competitor.decks || [];
}

/**
 * デッキデータを取得
 * @param {string} deckName - デッキ名
 * @returns {object|null} デッキデータ
 */
export function getDeck(deckName) {
  return DECKS[deckName] || null;
}

/**
 * NPCのランダムなデッキを取得
 * @param {string} competitorId - NPC ID
 * @returns {object|null} デッキデータ
 */
export function getRandomDeckForCompetitor(competitorId) {
  const deckNames = getCompetitorDeckNames(competitorId);
  if (deckNames.length === 0) return null;

  const randomIndex = Math.floor(Math.random() * deckNames.length);
  return getDeck(deckNames[randomIndex]);
}

/**
 * デッキをカードID配列に展開（シミュレーター用）
 * @param {object} deck - デッキデータ
 * @returns {string[]} カードIDの配列（40枚）
 */
export function expandDeckToCardIds(deck) {
  if (!deck || !deck.cards) return [];

  const cardIds = [];
  for (const entry of deck.cards) {
    for (let i = 0; i < entry.count; i++) {
      cardIds.push(entry.id);
    }
  }
  return cardIds;
}

/**
 * 基本8NPCのIDリストを取得
 * @returns {string[]} NPC IDの配列
 */
export function getBaseCompetitorIds() {
  return ['kain', 'seira', 'rowen', 'malik', 'garon', 'nova', 'mask', 'toma'];
}

/**
 * コレクター6人のIDリストを取得
 * @returns {string[]} NPC IDの配列
 */
export function getCollectorIds() {
  return ['pippo', 'liliane', 'galdos', 'misty', 'profNome', 'sisterEmma'];
}

/**
 * 全NPCのIDリストを取得（グランドカップ用）
 * @returns {string[]} NPC IDの配列
 */
export function getAllCompetitorIds() {
  return [
    ...getBaseCompetitorIds(),
    'elda',
    ...getCollectorIds(),
    'doppelganger',
  ];
}

/**
 * ドッペルゲンガーのIDを取得
 * @returns {string} ドッペルゲンガーのID
 */
export function getDoppelgangerId() {
  return 'doppelganger';
}

/**
 * ドッペルゲンガーかどうかを判定
 * @param {string} competitorId - NPC ID
 * @returns {boolean} ドッペルゲンガーならtrue
 */
export function isDoppelganger(competitorId) {
  return competitorId === 'doppelganger';
}

/**
 * 有効なNPCのみを取得（デッキが設定されているNPC）
 * @returns {string[]} NPC IDの配列
 */
export function getActiveCompetitorIds() {
  return Object.keys(COMPETITORS).filter(id => {
    const competitor = COMPETITORS[id];
    return competitor.decks && competitor.decks.length > 0;
  });
}

/**
 * NPCの表示名を取得
 * @param {string} competitorId - NPC ID
 * @returns {string} 表示名
 */
export function getCompetitorDisplayName(competitorId) {
  const competitor = COMPETITORS[competitorId];
  return competitor ? competitor.name : competitorId;
}

/**
 * NPCのポートレート（絵文字）を取得
 * @param {string} competitorId - NPC ID
 * @returns {string} ポートレート
 */
export function getCompetitorPortrait(competitorId) {
  const competitor = COMPETITORS[competitorId];
  return competitor?.portrait || '❓';
}

/**
 * NPCのAI難易度を取得
 * @param {string} competitorId - NPC ID
 * @returns {string} 難易度 ('easy' | 'normal' | 'hard')
 */
export function getCompetitorAIDifficulty(competitorId) {
  const competitor = COMPETITORS[competitorId];
  return competitor?.aiDifficulty || 'normal';
}
